import React from "react";
import { Empty } from "antd";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

interface Props {
  description: string;
}

export const Error = (props: Partial<Props>) => {
  const history = useHistory();

  const goBack = () => history.goBack();

  return (
    <div className="pd15 flex-center">
      <div className="flex flex-column">
        <Empty description={props?.description} />
        <Button style={{ marginTop: "1rem" }} onClick={goBack}>
          Trở về
        </Button>
      </div>
    </div>
  );
};
